import React from "react";
import PDFObject from "pdfobject";

import "./FileViewer.css";

interface IFileViewerProps {
    className?: string;

    url: string;
    mime: string;
    filename?: string;
}

class FileViewer extends React.Component<IFileViewerProps> {
    public render() {
        return (
            <div className={this.props.className || ""}>
                {this.mimeRender()}
                {this.props.children}
            </div>
        );
    }

    private mimeRender() {
        const { mime, url } = this.props;
        const mimeBase = mime.split('/', 1)[0] || "";

        switch (mimeBase) {
            case "image":
                return <img src={url} alt="" />
            case "audio":
                return <audio src={url} autoPlay={false} controls={true} playsInline={true} />
            case "video":
                return <video src={url} autoPlay={false} controls={true} playsInline={true} />
            case "application":
                if (mime === "application/pdf") {
                    if (PDFObject.supportsPDFs) {
                        return <object data={url} type={mime}>
                            <div>
                                You need a PDF viewer plugin to see this document.<br />
                                Alternatively, <a href={url} download={this.props.filename || true}>Click here</a> to download
                            </div>
                        </object>;
                    }
                    else {
                        return <iframe src={`/pdf?file=${url}`} title="Embedded PDF viewer" />;
                    }
                }
                break;
            case "text":
                if (mime !== "text/html") {
                    return <object data={url} type={mime} className="text-file">
                        <div>
                            Could not embed document.<br />
                            <a href={url} download={this.props.filename || true}>Click here</a> to download
                    </div>
                    </object>;
                }
                break;
            default:
                return <div>Could not embed content, <a href={url} download={this.props.filename || true}>Click here</a> to download</div>
        }

        return <div>Could not embed content, <a href={url} download={this.props.filename || true}>Click here</a> to download</div>
    }
}

export default FileViewer;
